import React, { Component } from 'react';
import { Modal } from 'reactstrap';
import { connect } from 'react-redux';

import { ModalUi } from './TrekOverviewModal';

import {
  closeOverviewModal,
  closeNestedOverviewModal,
} from '../../redux/actions/trekOverviewActions';
class EditModalContainer extends Component {
  render() {
    const {
      isModalOpen,
      component,
      props,
      // closeOverviewModal,
      closeNestedOverviewModal,
      nestedModal,
    } = this.props;
    return (
      <Modal
        isOpen={isModalOpen}
        className={
          component && component.indexOf('Editor') > -1
            ? component === 'PreferencesEditor'
              ? 'edit-modal pref-list'
              : 'edit-modal'
            : 'notification-modal'
        }
        toggle={this.handleModalToggle}
      >
        {isModalOpen && <ModalUi component={component} props={props} />}
        <Modal isOpen={nestedModal} toggle={closeNestedOverviewModal}>
          {nestedModal && <ModalUi component={nestedModal} />}
        </Modal>
      </Modal>
    );
  }
  handleModalToggle = () => {
    const { component, closeOverviewModal } = this.props;

    const modalsWithoutToggle = [
      'PreferencesEditor',
      'TrekNameAndDateEditor',
      'PriceEditor',
      'BasicInfoEditor',
      'LockTrek',
    ];

    const disableToggle = modalsWithoutToggle.indexOf(component) === -1;

    if (disableToggle) {
      return closeOverviewModal();
    }
  };
}

const mapStateToProps = ({ trekOverview }) => {
  return {
    isModalOpen: trekOverview.isModalOpen,
    component: trekOverview.component,
    props: trekOverview.props,
    nestedModal: trekOverview.nestedModal,
    // isModalOpen: alertModal.isModalOpen,
    // component: alertModal.notificationType
  };
};

const mapDispatchToProps = dispatch => {
  return {
    closeOverviewModal: () => dispatch(closeOverviewModal()),
    closeNestedOverviewModal: () => dispatch(closeNestedOverviewModal()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditModalContainer);



// WEBPACK FOOTER //
// ./src/components/TrekDetail/TrekOverviewModalContainer.jsx